import React, { useRef, useMemo, ReactElement } from 'react';
import { FormContainer } from '../form/FormContainer';
import FormWidget from '../form/FormWidget';
import FormItem from '../form/FormItem';
import { Icons } from '../icons/Icons';
import { SxProps } from '@mui/material';

type FormNameEditorProps = {
    value: string;
    name: string;
    label: string | ReactElement;
    onSave: () => void;
    onClose: Function;
    sx?: SxProps;
};

export default (props: FormNameEditorProps) => {
    const { value, name, label, onSave, onClose, sx = {} } = props;
    const nameRef = useRef<HTMLInputElement>(null);
    const initialValue = useMemo(() => {
        return value;
    }, []);

    return (
        <FormContainer>
            <FormItem>
                <FormWidget name={name} label={label} sx={{ ...sx }} value={value} ref={nameRef} />
                <Icons.CheckIcon
                    data-testid="CheckIcon"
                    color="success"
                    fontSize="large"
                    sx={{
                        '&:hover': {
                            cursor: 'pointer'
                        }
                    }}
                    onClick={onSave}
                />
                <Icons.ClearIcon
                    data-testid="cancelIcon"
                    color="secondary"
                    fontSize="large"
                    sx={{
                        '&:hover': {
                            cursor: 'pointer'
                        }
                    }}
                    onClick={() => onClose(initialValue)}
                />
            </FormItem>
        </FormContainer>
    );
};
